import { memo } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './reserve-capacity-header.module.scss';

export const ReserveCapacityHeader = memo(() => {
	const { t } = useTranslation();

	return (
		<div className={styles.header}>
			<h4 className={styles.headerTitle}>{t('RESERVE_CAPACITY.TITLE')}</h4>
			<p className={styles.headerSubtitle}>{t('RESERVE_CAPACITY.SUBTITLE')}</p>
		</div>
	);
});

ReserveCapacityHeader.displayName = 'ReserveCapacityHeader';
